import "../chatuserinfor/chatuserinfor.scss";
import { useUserDatabase } from "../../lib/userDatabase";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import VideocamIcon from '@mui/icons-material/Videocam';
import EditIcon from '@mui/icons-material/Edit';
import noAvatarImg from "../../assets/noAvatar.png";

const Chatuserinfor = () => {
    const { currentUser } =useUserDatabase();
    
    const getProfileSrc = (pic) => {
        // if (!pic) return "/public/noAvatar.png";
        if (!pic) return noAvatarImg;
        return pic.startsWith("http") ? pic : "/upload/" + pic;
    };

    return (
        <div className="chatUserInfo">
            <div className="user">
                <img
                    src={getProfileSrc(currentUser.profilePic)} 
                    alt=""
                />

                <h2 title={currentUser?.name}>
                    {currentUser.name}
                </h2>
            </div>

            <div className="icons">
                <MoreHorizIcon />
                <VideocamIcon />
                <EditIcon />
            </div>
        </div>
    )
}

export default Chatuserinfor
